export { default } from './Accordion';
export type { Props, Props as AccordionProps } from './Accordion';
